var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout"},[(!_vm.isVerticalScreen())?_c('basic-layout-h'):_c('basic-layout-v')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }